import { render, staticRenderFns } from "./CdkImageMetadata.vue?vue&type=template&id=210659bc&scoped=true&functional=true&"
import script from "./CdkImageMetadata.vue?vue&type=script&lang=ts&"
export * from "./CdkImageMetadata.vue?vue&type=script&lang=ts&"
import style0 from "./CdkImageMetadata.vue?vue&type=style&index=0&id=210659bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "210659bc",
  null
  
)

export default component.exports